import React, { type FC } from 'react';
import { AffirmMethod } from '../methods/Affirm';
import { CreditCardMethod } from '../methods/CreditCard';
import { AtomeMethod } from '../methods/Atome';
import { GenericMethod } from '../methods/Generic';
import { type ClientBnplMethodInfo } from '../../types/ClientBnplMethodInfo';
import { InstallmentPaymentMethod } from '../../types/InstallmentPaymentMethod';

export interface PaymentMethodItemProps {
  pmInfo: ClientBnplMethodInfo;
}

const PMComponents: Partial<Record<InstallmentPaymentMethod, FC<PaymentMethodItemProps>>> = {
  [InstallmentPaymentMethod.Affirm]: AffirmMethod,
  [InstallmentPaymentMethod.Atome]: AtomeMethod,
  [InstallmentPaymentMethod.CreditCard]: CreditCardMethod,
};

export const PaymentMethodItem = (props: PaymentMethodItemProps) => {
  const Method = PMComponents[props.pmInfo.paymentMethod] || GenericMethod;

  return <Method pmInfo={props.pmInfo} />;
};
